import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';

const returnPlaceholderFocused = ({
  nodeType,
  isFocused,
  nodeText,
  dateInput,
  isCurrent,
  minNodeText,
  noPlaceHolder,
}) => {
  if (
    nodeType !== 'summary' &&
    (isFocused ||
      nodeText ||
      dateInput ||
      isCurrent ||
      minNodeText ||
      noPlaceHolder)
  ) {
    return css`
      font-size: ${(props) =>
        props.noPlaceHolder && !props.isFocused ? '12px' : '12px'};
      line-height: 16px;
      top: 0px;
      color: ${isFocused ? '#8510DF' : 'none'};
      background: #ffffff;
      border-radius: 4px;
      padding: 0 4px;
      left: 6px;
      transition: top 0.3s ease-in-out;

      @media ${breakpointsMinWidth.mobileMicroLg} {
        left: 10px;
      }

      @media ${breakpointsMinWidth.tabletSm} {
        left: 5px;
      }

      @media ${breakpointsMinWidth.desktopSm} {
        left: 6px;
      }

      @media ${breakpointsMinWidth.desktopMd} {
        left: 10px;
        font-size: ${(props) =>
          props.noPlaceHolder && !props.isFocused ? '14px' : '12px'};
      }
    `;
  }
  return null;
};
const PlaceHolder = styled.div`
  position: absolute;
  max-width: 100%;
  pointer-events: none;
  display: inline-block;
  font-family: Roboto;
  font-weight: normal;
  font-style: normal;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  top: 50%;
  color: #878787;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
  transition: top 0.3s ease-in-out;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
  ${(props) => returnPlaceholderFocused(props)}
  ${(props) => {
    const { nodeType, isFocused, nodeText, noPlaceHolder } = props;

    if (nodeType === 'phone_number' || nodeType === 'sender_phone_number') {
      return css`
        padding-left: ${!isFocused && !nodeText ? '60px' : '0px'};
        margin-left: ${isFocused || nodeText ? '50px' : '0px'};
        padding-left: ${isFocused || nodeText ? '4px' : 'null'};
        width: inherit;
      `;
    }

    if ((!isFocused || isFocused) && nodeType === 'summary') {
      return css`
        top: 16px;
        display: ${nodeText || noPlaceHolder ? 'none' : 'block'};
      `;
    }
    return null;
  }}
`;

export default PlaceHolder;
